import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { connectRequest } from 'redux-query';
import { fetchUserByNameConfig } from 'dash-front/admin/actions/accounts';
import CardText from 'material-ui/Card/CardText';
import IconAccount from 'material-ui/svg-icons/action/account-box';
import PageCardWrapper from 'dash-front/components/PageCardWrapper';
import PacksSection from './PacksSection';
import FeaturesSection from './FeaturesSection';

function UpdateAccount({
    account: { _id: accountId = '', permissions, packs = [] },
    queryAccount: { isFinished: isFinishedAccount = false },
    params: { username: paramsUserName }
}) {
    return (
        <PageCardWrapper
            title={`Edit account ${paramsUserName}`}
            IconHeader={IconAccount}
            isFinished={isFinishedAccount}
            isError={!accountId}
            errorText={`Not found user ${paramsUserName}`}
        >
            <CardText>
                <FeaturesSection userId={accountId} permissions={permissions} />
                <PacksSection userId={accountId} userPacksList={packs} />
            </CardText>
        </PageCardWrapper>
    );
}

UpdateAccount.propTypes = {
    account: PropTypes.shape({
        _id: PropTypes.string.isRequired,
        username: PropTypes.string.isRequired,
        permissions: PropTypes.object.isRequired,
        packs: PropTypes.array.isRequired
    }),
    queryAccount: PropTypes.shape({ isFinished: PropTypes.bool.isRequired }),
    params: PropTypes.shape({ username: PropTypes.string })
};

export default compose(
    connectRequest(({ params }) => fetchUserByNameConfig(params.username)),
    connect(({ query = { entities: {}, queries: {}, list: {} } }, { params }) => ({
        account: get(query.entities.accounts, params.username, {
            _id: '',
            username: '',
            permissions: {},
            packs: []
        }),
        queryAccount: get(query.queries, `GET:accounts/${params.username}`, { isFinished: false })
    }))
)(UpdateAccount);



/** WEBPACK FOOTER **
 ** ../src/dash/front/admin/components/Account/UpdateAccount/UpdateAccount.js
 **/